<div>
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>{{title}}</h2>
  </div>
  <main class="form-signin border p-4 rounded">
    <form [formGroup]="quotationForm" (ngSubmit)="submit()">
      <div [formGroupName]="'quotationFields'">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-floating">
              <select formControlName="quotationMadeById" id="quotationMadeById" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationMadeById')?.errors">
                <option value=null disabled>Select User</option>
                <option *ngFor="let user of quotationUsers" [value]="user.id">{{ user.username
                  }}
                </option>
              </select>
              <label for="quotationMadeById">Made By <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationMadeById')?.errors"
                class="text-danger">Client is required</span>
            </div>
          </div>
          <!-- Dropdown 2 -->
          <div class="col-md-6">
            <div class="form-floating">
              <select formControlName="quotationAssignedToId" id="quotationAssignedToId" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationAssignedToId')?.errors">
                <option value=null disabled>Select User</option>
                <option *ngFor="let user of quotationUsers" [value]="user.id">{{ user.username
                  }}
                </option>
              </select>
              <label for="quotationAssignedToId">Assign To <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationAssignedToId')?.errors"
                class="text-danger"> Assign To is
                required</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <!-- Quote Id -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" [disabled]="true" class="form-control" id="quotationId"
                formControlName="quotationId" />
              <label for="quotationId">Quote Id</label>
            </div>
          </div>
          <!-- Quotation Date -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="date" class="form-control" id="quotationDate" formControlName="quotationDate" />
              <label for="quotationDate">Quotation Date <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationDate')?.errors"
                class="text-danger">
                Date is required
              </span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <input type="date" class="form-control" id="quotationFollowUpDate"
                formControlName="quotationFollowUpDate" />
              <label for="quotationFollowUpDate">Follow-up Date</label>
            </div>
          </div>

          <!-- Stage Dropdown -->
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="quotationStage" id="quotationStage" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationStage')?.errors">
                <option value=null disabled>Select Stage</option>
                <option value="publish">Publish</option>
                <option value="draft">Draft</option>
                <option value="proforma">Convert to Proforma</option>
              </select>
              <label for="quotationStage">Stage <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationStage')?.errors"
                class="text-danger">Stage is
                required</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <!-- Company Dropdown -->
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="quotationCompanyId" id="quotationCompanyId" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationCompanyId')?.errors"
                (change)="onCompanyChange()">
                <option value=null disabled>Select Company</option>
                <option *ngFor="let company of quotationCommonServices.clientsList" [value]="company.id">{{
                  company.companyName }}</option>
              </select>
              <label for="quotationCompanyId">Company <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationCompanyId')?.errors"
                class="text-danger">Company is required</span>
            </div>
          </div>
          <!-- Attention Dropdown -->
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="quotationAttentionId" id="quotationAttentionId" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationAttentionId')?.errors">
                <option value=null disabled>Select Attention</option>
                <option *ngFor="let member of companyMembersList" [value]="member.id">{{ member.memberName }}</option>
              </select>
              <label for="quotationAttentionId">Attention <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationAttentionId')?.errors"
                class="text-danger">Attention
                is
                required</span>
            </div>
          </div>
          <!-- Reference Text Field -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="reference" formControlName="reference"
                placeholder="Enter Reference" />
              <label for="reference">Reference</label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('reference')?.errors"
                class="text-danger">Reference is
                required</span>
            </div>
          </div>
          <!-- Importance Dropdown -->
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="quotationImportance" id="quotationImportance" class="form-control"
                [class.is-invalid]="submitted && quotationForm.get('quotationFields')?.get('quotationImportance')?.errors">
                <option value=null disabled>Select Importance</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="very-high">Very High</option>
              </select>
              <label for="quotationImportance">Importance <span class="text-danger">*</span></label>
              <span *ngIf="submitted && quotationForm.get('quotationFields')?.get('quotationImportance')?.errors"
                class="text-danger">Importance
                is
                required</span>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <!-- Quotation Priority Slider -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="range" min="0" max="5" id="quotationPriority" formControlName="quotationPriority"
                (input)="onPriorityChange($event)" />
              <label for="quotationPriority">Quotation Priority: {{quotationData?.quotationFields?.quotationPriority ||
                currentPriority }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-5">
        <h3><strong>Quotation Preview</strong></h3>
      </div>
      <div class="border p-2 rounded">
        <!-- Table for items -->

        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-primary mb-3" (click)="addRow()">Add Row</button>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="col-sr-no">Sr No</th>
                  <th class="col-description">
                    Description <span class="text-danger" *ngIf="quotationItems.length > 0 && hasVisibleRows()">*</span>
                  </th>
                  <th class="col-quantity">Quantity <span class="text-danger"
                      *ngIf="quotationItems.length > 0 && hasVisibleRows()">*</span></th>
                  <th class="col-unit">
                    Unit <span class="text-danger" *ngIf="quotationItems.length > 0 && hasVisibleRows()">*</span>
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-primary" (click)="openAddUpdateUnitDialog()"
                        title="Add Unit">
                        +
                      </button>
                    </div>
                  </th>
                  <th class="col-cost">Cost</th>
                  <th class="col-margin">Margin (%)</th>
                  <th class="col-packaging-charges">Packaging Charges (%)</th>
                  <th class="col-unit-price">Unit Price</th>
                  <th class="col-total-price">Total Price <span class="text-danger"
                      *ngIf="quotationItems.length > 0 && hasVisibleRows()">*</span></th>
                  <th class="col-actions">Actions</th>
                </tr>
              </thead>
              <tbody formArrayName="quotationItems">
                <ng-container *ngFor="let item of quotationItems.controls; let i = index">
                  <tr *ngIf="item.get('isDeleted')?.value !== true" [formGroupName]="i">

                    <td class="col-sr-no">{{ getSerialNumber(i) }}</td>
                    <td class="col-description">
                      <textarea class="form-control auto-resize" formControlName="description" rows="1"
                        placeholder="Description" (input)="autoResize($event)"></textarea>
                      <span *ngIf="submitted && item.get('description')?.errors && hasVisibleRows()"
                        class="text-danger">
                        Description is required
                      </span>
                      <textarea class="form-control auto-resize our-comments-textarea mt-2" formControlName="comments" rows="1"
                        placeholder="(Comments)" (input)="autoResize($event)"></textarea>
                    </td>
                    <td class="col-quantity"><input type="text" (input)="onQuantityChanged(i)"
                        class="form-control" formControlName="quantity">
                      <span *ngIf="submitted && item.get('quantity')?.errors && hasVisibleRows()" class="text-danger">
                        Quantity is required
                      </span>
                    </td>
                    <td class="col-unit">
                      <div class="d-flex align-items-center">
                        <select class="form-control me-2" formControlName="unit">
                          <option value="" disabled selected>Select Unit</option>
                          <option *ngFor="let unit of quotationCommonServices.unitsList" [value]="unit.id">
                            {{ unit.unitName }}
                          </option>
                        </select>
                      </div>
                      <span *ngIf="submitted && item.get('unit')?.invalid && hasVisibleRows()" class="text-danger">
                        Please select a unit
                      </span>
                    </td>

                    <td class="col-cost"><input type="text" (input)="onCostRelatedFieldChanged(i)"
                        class="form-control" formControlName="cost"></td>
                    <td class="col-margin"><input type="text" (input)="onCostRelatedFieldChanged(i)"
                        class="form-control" formControlName="margin"></td>
                    <td class="col-packaging-charges"><input type="text"
                        (input)="onCostRelatedFieldChanged(i)" class="form-control"
                        formControlName="packagingCharges"></td>
                    <td class="col-unit-price"><input type="text" (input)="onUnitPriceChanged(i)"
                        class="form-control" formControlName="unitPrice">  
                    </td>
                    <td class="col-total-price">
                      <input type="hidden" formControlName="totalPrice" />
                      <input type="text" class="form-control" [value]="getTotalPriceDisplay(item)" disabled />
                    </td>
                    <td class="col-actions">
                      <button type="button" class="btn btn-danger btn-sm" (click)="removeRow(i)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-3 justify-content-end border-top p-3" [formGroupName]="'quotationFields'">
          <div class="col-md-2">
            <div class="summary-fields d-flex flex-column align-items-end">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="netTotal" formControlName="netTotal" [disabled]="true" />
                <label for="netTotal">Net Total</label>
              </div>
              <div class="form-floating mb-3">
                <select (ngModelChange)="calculateGrandTotal()" formControlName="discountType" id="discountType"
                  class="form-control">
                  <option value=null disabled>Select Percent</option>
                  <option value="percent">Percent</option>
                  <option value="value">Value</option>
                </select>
                <label for="discountType">Discount Type</label>
              </div>
              <div class="form-floating mb-3">
                <input (ngModelChange)="calculateGrandTotal()" type="text" class="form-control" id="discount"
                  formControlName="discount" />
                <label for="discount">Discount</label>
              </div>
              <div class="form-floating mb-3">
                <input (ngModelChange)="calculateGrandTotal()" type="text" class="form-control" id="otherCharges"
                  formControlName="otherCharges" />
                <label for="otherCharges">P&F Charges</label>
              </div>



            </div>
          </div>
          <div class="row justify-content-end border-tops p-3">
            <div class="col-md-3">

              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input type="checkbox" class="form-check-input" id = "isGstRemoved" formControlName="isGstRemoved"
                    (change)="onToggleRemoveGst()" />
                  <label class="form-check-label" for="isGstRemoved">Remove GST</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="gstAmount" formControlName="gstAmount"
                    [disabled]="true" />
                  <label for="gstAmount">GST Amount</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3 justify-content-end border-tops p-3">
            <div class="col-md-3">
              <div class="d-flex align-items-center mb-3">
                <div class="form-check me-2">
                  <input type="checkbox" class="form-check-input" id = "roundOff" formControlName="isRoundOff" (change)="toggleRoundOff($event)" />
                  <label class="form-check-label" for="roundOff">Round off</label>
                </div>
                <div class="flex-grow-1" style="max-width: 100%;">
                  <div class="form-floating">
                    <input type="text" class="form-control" id="grandTotal" formControlName="grandTotal"
                      [disabled]="true" />
                    <label for="grandTotal"><b>Grand Total</b></label>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>


      <div [formGroupName]="'quotationTerms'">
        <div class="row mb-3 mt-5">
          <div class="col-md-12">
            <h3><strong>Terms and Conditions</strong></h3>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="deliveryNameId" class="form-control">
                <option value=null>Select Delivery</option>
                <option *ngFor="let option of quotationCommonServices.deliveredTosList" [value]="option.id">{{
                  option.deliveryName }}</option>
              </select>
              <label for="deliveryNameId">Delivered To</label>

            </div>
          </div>

          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="currencyId" class="form-control">
                <option value=null>Select Currency</option>
                <option *ngFor="let option of quotationCommonServices.currenciesList" [value]="option.id">{{
                  option.currencyName }}</option>
              </select>
              <label for="currencyId">Currency</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="deliveryTimeId" class="form-control">
                <option value=null>Select Delivery Time</option>
                <option *ngFor="let option of quotationCommonServices.deliveryTimesList" [value]="option.id">{{
                  option.deliveryTime }}</option>
              </select>
              <label for="deliveryTimeId">Delivery Time</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="countryofOriginId" class="form-control">
                <option value=null>Select Country Of Origin</option>
                <option *ngFor="let option of quotationCommonServices.countriesList" [value]="option.id">{{
                  option.countryName }}</option>
              </select>
              <label for="countryofOriginId">Country Of Origin</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="paymentId" class="form-control">
                <option value=null>Select Payment</option>
                <option *ngFor="let option of quotationCommonServices.paymentsList" [value]="option.id">{{
                  option.paymentType }}</option>
              </select>
              <label for="paymentId">Payment</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="mtcTypeId" class="form-control">
                <option value=null>Select MTC Type</option>
                <option *ngFor="let option of quotationCommonServices.mtcTypesList" [value]="option.id">{{
                  option.mtcType }}
                </option>
              </select>
              <label for="mtcTypeId">MTC Type</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="validityId" class="form-control">
                <option value=null>Select Quotation Validity</option>
                <option *ngFor="let option of quotationCommonServices.validitiesList" [value]="option.id">{{
                  option.validity
                  }}</option>
              </select>
              <label for="validityId">Quotation Validity</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="packingTypeId" class="form-control">
                <option [ngValue]=null>Select Packing Type</option>
                <option *ngFor="let option of quotationCommonServices.packingTypesList" [value]="option.id">{{
                  option.transportMode }}</option>
              </select>
              <label for="packingTypeId">Packing Type</label>
            </div>
          </div>
        </div>
      </div>
      <!-- Submit Button -->
      <div class="row mb-3">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary" [disabled]="quotationForm.pristine || quotationForm.invalid">Submit</button>
        </div>
      </div>
    </form>
  </main>

</div>